/**
 * Defines i18n keys in common namespace
 */
const NAMESPACES = {
  common: "common",
  template: "template",
  modeler: "modeler",
};

const COMMON = {
    
};

const MODELER = {};

const TEMPLATE = {
  modelerDescription: `${NAMESPACES.template}:modelerDescription`,
  modelerTitle: `${NAMESPACES.template}:modelerTitle`,
  templateTitle: `${NAMESPACES.template}:templateTitle`,
  templateDescription: `${NAMESPACES.template}:templateDescription`,
  solverLabel: `${NAMESPACES.template}:solverLabel`,
  solverPlaceholder: `${NAMESPACES.template}:solverPlaceholder`,
  topicsLabel: `${NAMESPACES.template}:topicsLabel`,
  topicsPlaceholder: `${NAMESPACES.template}:topicsPlaceholder`,
  industriesLabel: `${NAMESPACES.template}:industiesLabel`, // Note: There's a typo in "industiesLabel"; consider correcting it to "industriesLabel" in your JSON.
  industriesPlaceholder: `${NAMESPACES.template}:industiesPlaceholder`, // Same typo note as above.
  thumbnailImage: `${NAMESPACES.template}:thumbnailImage`,
  accessLabel: `${NAMESPACES.template}:accessLabel`,
  modelerPublicDescription: `${NAMESPACES.template}:modelerPublicDescription`,
  modelerAccessPublic: `${NAMESPACES.template}:modelerAccessPublic`,
  modelerPrivateDescription: `${NAMESPACES.template}:modelerPrivateDescription`,
  modelerAccessPrivate: `${NAMESPACES.template}:modelerAccessPrivate`,
  modelerDescriptionPlaceholder: `${NAMESPACES.template}:modelerDescriptionPlaceholder`,
  templateDescriptionPlaceholder: `${NAMESPACES.template}:templateDescriptionPlaceholder`,
  templatePublicDescription: `${NAMESPACES.template}:templatePublicDescription`,
  templateAccessPublic: `${NAMESPACES.template}:templateAccessPublic`,
  templatePrivateDescription: `${NAMESPACES.template}:templatePrivateDescription`,
  templateAccessPrivate: `${NAMESPACES.template}:templateAccessPrivate`,
  promptModelerDescription: `${NAMESPACES.template}:promptModelerDescription`,
  promptTemplateDescription: `${NAMESPACES.template}:promptTemplateDescription`,
  templateThumbnailImage: `${NAMESPACES.template}:templateThumbnailImage`,
  modelerThumbnailImage: `${NAMESPACES.template}:modelerThumbnailImage`,
  objUploadingProgress: `${NAMESPACES.template}:objUploadingProgress`,
  objUploadSuccess: `${NAMESPACES.template}:objUploadSuccess`,
  objOneFileWarning: `${NAMESPACES.template}:objOneFileWarning`,
  objNoFileUploaded: `${NAMESPACES.template}:objNoFileUploaded`
};

const DEFAULT_LANGUAGE = "en";
const DEFAULT_NAMESPACE = NAMESPACES.common;

export {
  COMMON,
  DEFAULT_LANGUAGE,
  DEFAULT_NAMESPACE,
  NAMESPACES,
  MODELER,
  TEMPLATE,
};
